import {timeFrames} from "./staticData";
import dates from "./dates";
import store from "../store";
import {ENUMS} from "./enums";
import {MODELS} from "./models";

const filters = {
  byCampaigns(items, campaignFilter) {
    return items.filter(item => {
      // return all leads if campaigns set to null aka no filter
      if (campaignFilter === null) {
        return true;
      }

      // Leads with no campaign
      if (campaignFilter === -1) {
        if (item.campaign_id === null) {
          return true;
        }
      }

      // Leads with any campaign
      if (campaignFilter === -2) {
        if (item.campaign_id) {
          return true;
        }
      }

      if (item.campaign_id) {
        return item.campaign_id === campaignFilter;
      }

      return false;
    });
  },
  byMultipleCampaigns(items, campaignFilters) {
    return items.filter(item => {
      if (campaignFilters.length === 0) return true

      // Leads with no campaign
      if (campaignFilters.includes(-1) && item.campaign_id === null) return true

      if (item.campaign_id) return !!campaignFilters.includes(item.campaign_id)

      return false
    });
  },
  byCreatedMultiplePhoneNumbers(items, phoneNumbers) {
    return items.filter(item => {
      if (phoneNumbers.length === 0) return true

      if (item.createdBy.class_name === MODELS.IntegrationPhoneNumber.class_name) {
        return !!phoneNumbers.includes(item.createdBy.id)
      }

      return false
    });
  },
  byDeal(items, dealFilter) {
    return items.filter(item => {
      // Leads & Deals
      if (dealFilter === 0) {
        return true;
      }

      // Leads
      if (dealFilter === 1) {
        return item.deal_at === null;
      }

      // Deals
      if (dealFilter === 2) {
        return item.deal_at;
      }

      return false;
    });
  },
  byExitStrategy(items, exitStrategyFilter) {
    return items.filter(item => {
      if (exitStrategyFilter === 0) {
        return true;
      }

      if (item.exit_strategy) {
        return item.exit_strategy === exitStrategyFilter;
      }

      return false;
    });
  },
  byNextContactAt(items, nextContactAtFilter) {
    return items.filter(item => {
      if (nextContactAtFilter === 0 || !item.next_contact_at) {
        return true;
      }

      const now = new Date();
      const nextContactAt = new Date(item.next_contact_at);

      return nextContactAt.getTime() <= now.getTime();
    });
  },
  bySequence(items, sequenceFilter) {
    return items.filter(item => {
      // return all leads if sequences set to null aka no filter
      if (!sequenceFilter) {
        return true;
      }

      return sequenceFilter === item.active_sequence_template_id;
    });
  },
  bySequenceStatus(items, sequenceStatusFilter) {
    return items.filter(item => {
      // return all leads if sequence status set to null aka no filter
      if (!sequenceStatusFilter) {
        return true;
      }

      return sequenceStatusFilter === item.active_sequence_status;
    });
  },
  bySource(items, sourceFilter) {
    return items.filter(item => {
      // return all leads if sources set to null aka no filter
      if (!sourceFilter) {
        return true;
      }

      if (sourceFilter === ENUMS.IntegrationTypeEnum.LaunchControl.value) {
        const launchControl = store.getters.launchControlIntegration
        return launchControl && launchControl.id === item.createdBy.id && MODELS.Integration.class_name === item.createdBy.class_name
      }

      return sourceFilter === item.createdBy.class_name;
    });
  },
  byStatus(items, statusFilter) {
    return items.filter(item => {
      // return all leads if statuses set to null aka no filter
      if (!statusFilter) {
        return true;
      }

      // TODO: pipeline-overhaul Need to make sure item has the current_status_id
      return statusFilter === item.current_status_id;
    });
  },
  byTemperature(items, temperatureFilter) {
    return items.filter(item => {
      if (temperatureFilter === '' || temperatureFilter === null) {
        return true;
      }

      if (item.temperature !== '') {
        return item.temperature === temperatureFilter;
      }

      return false;
    });
  },
  byDealProbabilityScore(items, dealProbabilityScoreFilter) {
    return items.filter(item => {
      if (dealProbabilityScoreFilter === '' || dealProbabilityScoreFilter === null) {
        return true;
      }

      if (item.deal_probability_score !== '') {
        return item.deal_probability_score === dealProbabilityScoreFilter;
      }

      return false;
    });
  },
  byTimeframe(items, timeframeFilter) {
    return items.filter(item => {
      if (!timeframeFilter || timeframeFilter === 0) {
        return true;
      }

      const modifiedAt = dates.getISO(item.updated_at);
      const time = timeFrames.find(t => t.value === timeframeFilter);

      if (time) {
        return dates.isAfter(modifiedAt, time.start) && dates.isBefore(modifiedAt, time.end);
      }

      return false;
    });
  },
  byUsers(items, userFilter) {
    return items.filter(item => {
      if (userFilter.length === 0) {
        return true;
      }

      // Filter set to 'no users' and item has no users
      if (userFilter.includes(0) && item.users.length === 0) {
        return true;
      }

      return item.users.some(user => userFilter.includes(user.id));
    });
  },
};

export default filters;
